import { getLineProductName } from "./get-line-product-name";
import { AppProductLine, ProductDataPropertyNameType } from 'graphql/models/extended';
import { ProductDataProperty } from 'graphql/models/generated'

export function getProductName(position: AppProductLine): string {
    return isOtherConfigurableProduct(position.product?.name ?? '')
    ? 'Sonstige' // TODO: add translation?
    : getLineProductName(position);
}

export function isOtherConfigurableProduct(productName: string): boolean {
    return productName.toLowerCase().includes('sonstige');
}

export function getProductProperty(
  properties: ProductDataProperty[],
  name: ProductDataPropertyNameType
): ProductDataProperty | undefined {
    if (
      Array.isArray(properties)
      && typeof name === 'string' && name.length > 0
    ) {
        const prop = properties.find((prop) => prop.name === name);

        if (prop && typeof prop === 'object') {
            return prop;
        }
    }

    return undefined;
}

export function getProductPropertyValue(
  properties: ProductDataProperty[],
  name: ProductDataPropertyNameType
): string {
    const prop = getProductProperty(properties, name);

    return prop && typeof prop.value === 'string' ? prop.value : '';
}
